<template>
  <v-footer
    class="white-flat-border-top"
    :inset="true"
    app
  >
    <v-row>
      <v-col cols="12" class="text-center text-caption pa-2">
         &copy; {{ new Date().getFullYear() }} - Controle de Frota
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {};
</script>

<style lang="scss"></style>
